import React from 'react';

export const CampfireIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M20,80 Q50,90 80,80 L70,70 L30,70 Z" fill="#8B4513" stroke="#0E1B33" strokeWidth="4"/>
    <path d="M30,75 C20,50 40,30 50,20 C60,30 80,50 70,75 Z" fill="#F6A21E" stroke="#0E1B33" strokeWidth="4"/>
    <path d="M40,75 C35,60 45,45 50,40 C55,45 65,60 60,75 Z" fill="#F7E03C" stroke="#0E1B33" strokeWidth="4"/>
  </svg>
);

export const DockIcon = () => (
  <svg viewBox="0 0 100 100">
    <rect x="20" y="40" width="60" height="40" fill="#D2B48C" stroke="#0E1B33" strokeWidth="4" rx="4"/>
    <line x1="30" y1="40" x2="30" y2="90" stroke="#0E1B33" strokeWidth="6" strokeLinecap="round"/>
    <line x1="70" y1="40" x2="70" y2="90" stroke="#0E1B33" strokeWidth="6" strokeLinecap="round"/>
    <path d="M20,50 L80,50 M20,60 L80,60 M20,70 L80,70" stroke="#0E1B33" strokeWidth="2"/>
  </svg>
);

export const TreasureIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M10,60 L90,60 L80,90 L20,90 Z" fill="#8B4513" stroke="#0E1B33" strokeWidth="4"/>
    <path d="M15,60 C30,40 70,40 85,60 Z" fill="#D2B48C" stroke="#0E1B33" strokeWidth="4"/>
    <circle cx="50" cy="55" r="8" fill="#F7E03C" stroke="#0E1B33" strokeWidth="3"/>
    <circle cx="35" cy="50" r="6" fill="#F7E03C" stroke="#0E1B33" strokeWidth="3"/>
    <circle cx="65" cy="50" r="6" fill="#F7E03C" stroke="#0E1B33" strokeWidth="3"/>
  </svg>
);

export const HoleIcon = () => (
  <svg viewBox="0 0 100 100">
    <ellipse cx="50" cy="50" rx="40" ry="20" fill="#0E1B33"/>
    <ellipse cx="50" cy="50" rx="45" ry="25" fill="none" stroke="#5FA6F7" strokeWidth="4" strokeDasharray="10 5"/>
    <path d="M50,50 L50,70 M40,45 L30,55 M60,45 L70,55" stroke="#F45DB3" strokeWidth="3" strokeLinecap="round"/>
  </svg>
);

export const TrailIcon = () => (
  <svg viewBox="0 0 100 100">
    <rect x="40" y="20" width="20" height="30" fill="#D2B48C" stroke="#0E1B33" strokeWidth="4" rx="2"/>
    <line x1="50" y1="50" x2="50" y2="80" stroke="#0E1B33" strokeWidth="6" strokeLinecap="round"/>
    <path d="M45,30 L55,30 M45,40 L55,40" stroke="#0E1B33" strokeWidth="2"/>
  </svg>
);

export const HutIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M20,60 L80,60 L80,90 L20,90 Z" fill="#D2B48C" stroke="#0E1B33" strokeWidth="4"/>
    <path d="M10,60 L50,20 L90,60 Z" fill="#8B4513" stroke="#0E1B33" strokeWidth="4"/>
    <rect x="40" y="60" width="20" height="30" fill="#0E1B33"/>
  </svg>
);

export const TreeIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M40,90 L40,50 L60,50 L60,90 Z" fill="#8B4513" stroke="#0E1B33" strokeWidth="4"/>
    <circle cx="50" cy="35" r="25" fill="#3BB54A" stroke="#0E1B33" strokeWidth="4"/>
    <circle cx="30" cy="45" r="20" fill="#3BB54A" stroke="#0E1B33" strokeWidth="4"/>
    <circle cx="70" cy="45" r="20" fill="#3BB54A" stroke="#0E1B33" strokeWidth="4"/>
  </svg>
);

export const MudIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M10,50 Q30,20 50,50 T90,50 Q70,80 50,80 T10,50 Z" fill="#8B4513" stroke="#0E1B33" strokeWidth="4"/>
    <circle cx="40" cy="45" r="4" fill="#0E1B33"/>
    <circle cx="60" cy="55" r="6" fill="#0E1B33"/>
    <circle cx="30" cy="60" r="3" fill="#0E1B33"/>
  </svg>
);

export const ShackIcon = () => (
  <svg viewBox="0 0 100 100">
    <path d="M15,50 L85,45 L80,90 L20,90 Z" fill="#D2B48C" stroke="#0E1B33" strokeWidth="4"/>
    <path d="M5,50 L45,15 L95,45 Z" fill="#F45DB3" stroke="#0E1B33" strokeWidth="4"/>
    <rect x="40" y="60" width="25" height="30" fill="#0E1B33"/>
    <rect x="25" y="55" width="10" height="15" fill="#3D8DF5" stroke="#0E1B33" strokeWidth="2"/>
  </svg>
);
